import { render } from "./Alert.vue?vue&type=template&id=6f2e26d3"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/Alert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f2e26d3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f2e26d3', __exports__)) {
    api.reload('6f2e26d3', __exports__)
  }
  
  module.hot.accept("./Alert.vue?vue&type=template&id=6f2e26d3", () => {
    api.rerender('6f2e26d3', render)
  })

}


export default __exports__